export const STRING_REGEX = {
    SPECIAL_CHARACTERS: /[-[\]{}()*+?.,\\^$|#\s]/g,
    NOT_EMPTY: /([^\s])/,
    URL: /^(?:(?:https?:)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z0-9\u00a1-\uffff][a-zA-Z0-9\u00a1-\uffff_-]{0,62})?[a-zA-Z0-9\u00a1-\uffff]\.)+(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::\d{2,5})?(?:[/?#]\S*)?$/,
    EMAIL: /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)?$/,
    DATE: /^[A-Z][a-z][a-z]\s([1-9]|1[0-9]|2[0-9]|3[0-1]),\s[1-2][0-9][0-9][0-9]$/,
    TIME: /^([1-9]|1[0-2]):[0-5][0-9]\s*[AP][M]\s*$/,
    DOI: [
        /\b(10[.][0-9]{4,}(?:[.][0-9]+)*\/(?:(?!["&'<>])\S)+)\b$/i, // case example: 10.1016.12.31/nature.S0735-1097(98)2000/12/31/34:7-7
        /^10.\d{4,9}\/[-._;()/:A-Z0-9]+\/[-._;()/:A-Z0-9]+$/i, // case example: 10.1093/abt/tby001
        /^10.\d{4,9}\/[-._;()/:A-Z0-9]+$/i // case example: 10.1093/abt
    ],
    PMID: /^[0-9]+$/,
    PMCID: /^(pmc|PMC)[0-9]+$/,
    GOOGLE_DRIVE: /^(?:http(s)?:\/\/)?(drive|docs)(\.google\.com\/)((spreadsheets|document|forms|presentation|file|drive)\/).+$/,
    SHAREPOINT: /^(?:https?:\/\/)?.+(\.sharepoint\.com\/).+$/,
    YOUTUBE: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/,
    FILE_NAME_INVALID: /\\|\/|<|>|:|;|,|\?|"|\*|%|\$|\|/g,
    EMAIL_FILE: /(msg)$|(eml)$/
};
